var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.itemsCount > 0
    ? _c("div", { staticClass: "kiosk-basket-container" }, [
        _c(
          "button",
          {
            staticClass: "kiosk-checkout-btn checkoutButtonAnimationExtreme",
            on: {
              "&click": function ($event) {
                return _vm.gotoCart.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "kiosk-flex-wrapper" }, [
              !_vm.$store.getters.hidePrices
                ? _c("div", { staticClass: "price-section" }, [
                    _c("span", { staticClass: "currency-label" }, [
                      _vm._v("Gesamt"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "price-amount checkoutButtonText" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("price")(_vm.$store.getters.payerSum)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "action-section" },
                [
                  _c(
                    "v-badge",
                    {
                      staticClass: "flex-shrink-0",
                      attrs: {
                        color: "error",
                        content: _vm.itemsCount,
                        overlap: "",
                        "offset-x": "10",
                        "offset-y": "10",
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "white--text", attrs: { large: "" } },
                        [_vm._v("mdi-cart-arrow-right")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "checkout-text checkoutButtonText" },
                    [_vm._v(" Checkout ")]
                  ),
                  _c(
                    "v-icon",
                    {
                      staticClass: "white--text arrow-right",
                      attrs: { large: "" },
                    },
                    [_vm._v("mdi-chevron-right")]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }